/**
 * twitter, instagram, LINEの文言 2025/5/1~ 公開（LINEの場合は「＃」が不要かどうか確認）
 */
export const SNS_X_TEXT = `昨年150万回以上受検された早押しゲーム   #英語タイムアタック ⌛
2025年度版が公開中！ 

30秒でできる早押しゲームで、英単語力を楽しくチェックしよう！

何度も挑戦すると主人公が進化…🫢⁈
全国上位を目指そう👑
`;

export const SNS_INSTAGRAM_TEXT = `昨年150万回以上受検された早押しゲーム   #英語タイムアタック ⌛
パワーアップした最新版が公開中！ 

30秒でできる早押し３択ゲームで、あなたの英単語力を楽しくチェックしよう！

何度も挑戦すると主人公が進化…🫢⁈
全国上位を目指そう👑
`;

// LINEのときのみ「#」記号が不要
export const SNS_LINE_TEXT = `昨年150万回以上受検された早押しゲーム   英語タイムアタック ⌛
パワーアップした最新版が公開中！ 

30秒でできる早押し３択ゲームで、あなたの英単語力を楽しくチェックしよう！

何度も挑戦すると主人公が進化…🫢⁈
全国上位を目指そう👑
`;

/**
 * 結果ページからシェアされた場合の文言
 * 2025/5/1~ 公開（LINEの場合は「＃」が不要かどうか確認）
 */
export const SNS_SHARE_PAGE_TEXT = `#NHK出版 #英語タイムアタック
わたしの #ねこ魔王挑戦結果 は…🗡️😈

30秒間の早押しゲームで、英単語力を楽しくチェックできた！
何度も受検すると主人公が進化するみたい…🫢⁈

目指せ！全国上位✨
`;

// LINEのときのみ「#」記号が不要
export const SNS_SHARE_PAGE_LINE_TEXT = `NHK出版 英語タイムアタック 
わたしの ねこ魔王挑戦結果 は…🗡️😈

30秒間の早押しゲームで、英単語力を楽しくチェックできた！
何度も受検すると主人公が進化するみたい…🫢⁈

目指せ！全国上位✨
`;

// MEMO: TOPページ、結果ページ共通 末尾に挿入されるSNSごとのハッシュタグやアカウント名（LINEの場合は末尾にハッシュタグや@が不要なので無し）
export const SNS_TWITTER_HASHTAG = `#英語 #英語学習 #NHKテキスト @nhkp_gogakucafe`;
export const SNS_INSTAGRAM_HASHTAG = `#英語 #英語学習 #NHKテキスト @gogakucafe `;
